/* eslint-disable */
import React from 'react';
import styles from './style.module.scss';
import { useNav } from '../../../hooks/nav';
import { ReactComponent as BackIcon } from '../../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  const isFirst = currentIndex === 0;

  return (
    <div className={`page ${styles.top}`} style={{ gap: 0 }}>
      {!isFirst && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.image} />

      <div className={'wrapper-info'} style={{ paddingBottom: 90 }}>
        <Title tag='h2'>{t('onboarding.notAloneTransition.title')}</Title>
        <Text semibold className={styles.description}>
          {t('onboarding.notAloneTransition.text')}
        </Text>
        <div className='overlay'></div>
      </div>
      <div className={'next-wrapper'}>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'not-alone-transition',
            });
            onNext();
          }}
          title={t('onboarding.notAloneTransition.continue')}
        />
      </div>
    </div>
  );
}
export default Page;
